import React, { useState } from 'react';

const ProfilePicture = ({ user, className = "w-8 h-8 rounded-full" }) => {
  const [imageError, setImageError] = useState(false);

  // Fallback to a placeholder with user's initials or default avatar
  const getInitials = (name) => {
    if (!name) return 'U';
    return name
      .split(' ')
      .map(word => word.charAt(0))
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  const initials = getInitials(user?.displayName);

  // If user has a photoURL and no image error, try to show the image
  if (user?.photoURL && !imageError) {
    return (
      <img 
        src={user.photoURL} 
        alt={user.displayName || 'User'}
        className={className}
        onError={() => setImageError(true)}
      />
    );
  }

  // Show placeholder (either no photoURL or image failed to load)
  return (
    <div className={`${className} bg-slate-200 flex items-center justify-center text-slate-600 font-medium text-sm`}>
      {initials}
    </div>
  );
};

export default ProfilePicture;
